// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2064":"105464c6","3786":"52b7960f","4265":"52b7960f","5384":"be0f7b11","6646":"52b7960f"}[chunkId] + ".chunk.css";
};